// eslint-disable-next-line import/prefer-default-export
export const removeAll = (origSet, toBeRemoveSet) => {
  toBeRemoveSet.forEach(Set.prototype.delete, origSet);
};
